import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-style-three',
  templateUrl: './footer-style-three.component.html',
  styleUrls: ['./footer-style-three.component.scss']
})
export class FooterStyleThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
